import { apiClient, type ApiResponse } from '@shared/api/api-client';
import type { V2AuthContext } from '@shared/types/auth';

export const authContextApi = {
  async getCurrentContext(accessToken?: string): Promise<V2AuthContext> {
    const response = await apiClient.get<ApiResponse<V2AuthContext>>(
      '/auth/context',
      undefined,
      accessToken
        ? {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            useFreshSessionAuth: true,
            timeout: 30000,
            timeoutProfile: 'background',
            requestLabel: 'auth-context:get-current-context',
          }
        : {
            timeout: 30000,
            timeoutProfile: 'background',
            requestLabel: 'auth-context:get-current-context',
          },
    );
    return response.data;
  },

  async switchContext(organizationId: string | null): Promise<V2AuthContext> {
    const response = await apiClient.put<ApiResponse<V2AuthContext>>('/auth/context', {
      organizationId,
    });
    return response.data;
  },
};
